import { api } from './api'

class Locking {
  init() {
    window.addEventListener('focus', this.handleChange.bind(this))
    window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this))
  }

  handleChange () {
    if (document.visibilityState === 'hidden') {
      this.freezeReview()
    } else {
      this.unfreezeReview()
    }
  }

  handleBeforeUnload (event) {
    var element = event.srcElement.activeElement

    if (element.dataset.closeReview === 'true' || element.dataset.confirm || element.dataset.attachment) { return }

    this.closeLocking()
  }

  closeLocking() {
    const lockInputs = document.querySelectorAll('[data-lock-id]')
    const identityId = document.querySelector('[data-identity-id]')?.id

    if (lockInputs.length === 0 || !identityId) return

    lockInputs.forEach(lockInput => {
      var lockId = lockInput.value

      if (!lockId) return

      const submissionId = lockInput.parentElement.querySelector('[data-submission-id]').value

      api.submissions.unlock({ identityId, lockId, submissionId })
    })
  }

  freezeReview () {
    var sessionId = this.getReviewSessionId()
    if (!sessionId || sessionId === null) { return }

    api.reviewSessions
      .update({ id: sessionId })
      .then(response => response)
      .catch(error => error)
  }

  unfreezeReview () {
    var sessionId = this.getReviewSessionId()
    if (!sessionId || sessionId === null) { return }

    api.reviewSessions
      .update({ id: sessionId })
      .then(response => response.json)
      .then(json => {
        if (json === null) {
          this.showStaleDialog()
        }
      })
      .catch(error => error)
  }

  getReviewSessionId () {
    var submissionField = document.querySelectorAll('[id=review_session_id]')[0]

    if (!submissionField) { return null }

    return submissionField.value
  }

  showStaleDialog () {
    document.querySelector('#dialog').showModal()

    const button = document.querySelector('.dialog-accept')
    button.addEventListener('click', this.handleConfirmation.bind(this))
  }

  handleConfirmation () {
    window.location.href = '/submissions/all'
  }
}

export default Locking
